import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ProjectListItemModel } from './definitions/project-list-item.model';
import { BaseAppComponent } from '@ui/shared/feature-config';
import { AsyncPipe } from '@angular/common';
import { FilterMapperComponent } from '@ui/shared/ui-filter';
import { ListViewModule } from '@ui/shared/feature-list';
import { ProjectListItemDetailsComponent } from './components/project-list-item-details/project-list-item-details.component';
import {
    ProjectListItemPopupContentComponent,
} from './components/project-list-item-popup-content/project-list-item-popup-content.component';
import { MapWithSidebarModule } from '@ui/shared/feature-map';
import { CoreService } from '@ui/shared/util-api';
import { map } from 'rxjs';
import { toDataResult } from '@team23/ts-result';

@Component({
    selector: 'ui-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AsyncPipe,
        FilterMapperComponent,
        ListViewModule,
        ProjectListItemDetailsComponent,
        MapWithSidebarModule,
    ],
})
export class AppComponent extends BaseAppComponent<ProjectListItemModel> {

    protected _api = inject(CoreService);

    public mapAreas$ = this._api.getPlanningAreas({
        paginateBy: 50,
    })
        .pipe(
            map(response => response.data.map(entry => entry.coordinates ?? [])),
            toDataResult(),
        );

    constructor() {
        super(ProjectListItemPopupContentComponent);
    }
}
